export const downloadFile = (file: Blob, filename: string) => {
  const url = URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  a.remove();
};

const extractFilenameFromContentDisposition = (contentDisposition: string) => {
  const match = contentDisposition.match(/filename="(.+?)"/);
  return match ? match[1] : null;
};

export const getFilenameFromResponse = (response: Response, fallback = 'skycash-file'): string => {
  const amzContentDisposition = response.headers.get('x-amz-meta-content-disposition');
  if (amzContentDisposition) {
    const filename = extractFilenameFromContentDisposition(amzContentDisposition);
    if (filename) return filename;
  }
  return fallback;
};
